import { namespace } from 'vuex-class';
import { IFieldState } from './field.types';

export const Fields = namespace('documentEdit/assembler/fields');

export const state: IFieldState = {
  loading: false,
  documentId: null,
  fields: [],
  inEditMode: false,
  pageWidth: null,
  focusedFieldId: null,
  tabStartField: null,
  tabbedField: null,
  senderSignature: '',
  lastUpdatedFieldId: null,
  isDragging: false,
};

export enum EFieldAction {
  Load = 'load',
  LoadSuccess = 'loadSuccess',
  LoadFailed = 'loadFailed',

  Add = 'add',
  Remove = 'remove',
  ReplaceCreatedFields = 'replaceCreatedField',

  Update = 'update',
  UpdateFailed = 'updateFailed',

  SetTabStart = 'setTabStart',
  Tab = 'tab',
  Focus = 'focus',

  ChangeTextSize = 'changeTextSize',
  ChangeTextSizeFailed = 'changeTextSizeFailed',

  UpdatePageWidth = 'updatePageWidth',
  Align = 'align',
  AlignFailed = 'alignFailed',
  Move = 'move',

  LoadSenderSignature = 'loadSenderSignature',
  LoadSenderSignatureSuccess = 'loadSenderSignatureSuccess',
  LoadSenderSignatureFailed = 'loadSenderSignatureFailed',

  CorrectFieldPosition = 'correctFieldPosition',
  GetPageDimensions = 'getPageDimensions',

  SetLastUpdatedFieldId = 'setLastUpdatedFieldId',
  DragField = 'dragField',
}

export enum EFieldMutation {
  SetLoading = 'setLoading',
  SetDocumentId = 'setDocumentId',
  SetPageWidth = 'setPageWidth',
  Set = 'set',
  Add = 'add',
  Remove = 'delete',
  Update = 'update',
  SetFocusedFieldId = 'setFocusedFieldId',
  SetSenderSignature = 'setSenderSignature',
  SetTabStartField = 'setTabStartField',
  SetTabbedField = 'setTabbedField',
  SetLastUpdatedFieldId = 'setLastUpdatedFieldId',
  SetDragField = 'setDragField',
}

export enum EFieldGetter {
  FieldsToFillOut = 'fieldsToFillOut',
  LastUpdatedField = 'lastUpdatedField',
}
